import { Container } from '@mui/material';
import { useMemo } from 'react';

import SmallSectionLoader from '../../elements/SmallSectionLoader';
import HomeDefectMetrics from './HomeDefectMetrics';
import TestAutomationMetrics from './TestAutomationMetrics';

const OrgMetricsReports = ({ projectIds, pageLoading, pageError }) => {
  const automationProjectIdsForQuery = useMemo(
    () => projectIds || [],
    [projectIds]
  );

  if (pageLoading) {
    return <SmallSectionLoader />;
  }

  return (
    <Container maxWidth="xxl" sx={{ my: 3 }}>
      <TestAutomationMetrics projectIds={automationProjectIdsForQuery} page='reports' />
      <HomeDefectMetrics projectIds={automationProjectIdsForQuery} pageError={pageError} page='reports' />
    </Container>
  );
};

export default OrgMetricsReports;
